define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isAuthenticationChangedInAnotherTabError = exports.AuthenticationChangedInAnotherTabError = void 0;
    const AUTHENTICATION_CHANGED_IN_ANOTHER_TAB_ERROR_MESSAGE = "Authentication changed in another tab";
    /**
     * Raised when another browser tab updates authentication to a different user and the current tab must re-authenticate.
     */
    class AuthenticationChangedInAnotherTabError extends Error {
        constructor() {
            super(AUTHENTICATION_CHANGED_IN_ANOTHER_TAB_ERROR_MESSAGE);
            this.name = "AuthenticationChangedInAnotherTabError";
        }
    }
    exports.AuthenticationChangedInAnotherTabError = AuthenticationChangedInAnotherTabError;
    const isAuthenticationChangedInAnotherTabError = (error) => error instanceof AuthenticationChangedInAnotherTabError ||
        (error instanceof Error && error.name === "AuthenticationChangedInAnotherTabError" && error.message === AUTHENTICATION_CHANGED_IN_ANOTHER_TAB_ERROR_MESSAGE);
    exports.isAuthenticationChangedInAnotherTabError = isAuthenticationChangedInAnotherTabError;
});
